import * as Yup from 'yup';

export default Yup.object({
  carrierId: Yup.string().required('Required'),
  existingCarrier: Yup.string()
});
